/* eslint-disable consistent-return */
/* eslint-disable radix */
import BaseComponent from 'foundation/base-component';
import HtmlHelper from 'foundation/html-helper';
import Cookies from 'js-cookie';
import userService from 'general/js/user/user-service';
import api from '../../../general/js/api';
import gtm from '../../../general/js/gtm';
import {
    TICKETS_DATA, domainTicketsConstants, displayConditionIsFulfilled
} from './helpers/bannerHelperConstants';

import { domainConstants } from '../../sso/components/utils/constants/domain-constants';
import { CookieNames } from '../../../general/js/utils/cookies';

class BannerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.retrievingData = { [domainConstants.theOpen]: false, [domainConstants.womensOpen]: false };
        this.init();
    }

    getCookieBannerName(cName) {
        return Cookies.get(cName);
    }

    setDataCookie(cookieName, cookieValue) {
        Cookies.set(cookieName, cookieValue, { expires: 2147483647 });
    }

    getDisplaySettingsOnBanner(banner) {
        const bannerDisplaySettingsJSON = this.getAttribute(banner, 'memberships');
        const bannerDisplaySettings = bannerDisplaySettingsJSON != null ? JSON.parse(bannerDisplaySettingsJSON) : null;
        const displaySettingsArray = [];

        if (bannerDisplaySettings !== null) {
            bannerDisplaySettings.forEach((element) => {
                displaySettingsArray.push(element.value);
            });
        }

        return displaySettingsArray;
    }

    getTicketsInfo(bannerDisplaySettings, domain) {
        if (!bannerDisplaySettings.some((element) => domainTicketsConstants[domain].includes(element))) {
            return null;
        }
        const ticketsData = userService.getJSONDataFromLocalStorage(TICKETS_DATA) || {};

        if (ticketsData && ticketsData[domain] && ticketsData[domain].expiryDate > new Date().toJSON()) {
            return ticketsData[domain].hasTickets;
        }

        return null;
    }

    getBannerIfItShouldBeDisplayed(userMemberships, banner) {
        const bannerDisplaySettings = this.getDisplaySettingsOnBanner(banner);

        const hasTicketsTO = this.getTicketsInfo(bannerDisplaySettings, domainConstants.theOpen);
        const hasTicketsWO = this.getTicketsInfo(bannerDisplaySettings, domainConstants.womensOpen);

        //if we dont have display settings, it means we are showing the banner to everyone
        if (bannerDisplaySettings.length === 0) return banner;

        const params = {
            bannerDisplaySettings, userMemberships, hasTicketsTO, hasTicketsWO
        };

        const conditionsResult = displayConditionIsFulfilled(params);
        const displayBanner = bannerDisplaySettings.reduce((
            accumulator, currentSetting
        ) => accumulator && conditionsResult[currentSetting], true);

        if (displayBanner === true) {
            return banner;
        }

        return null;
    }

    init() {
        if (!this.options.endpointUrl) {
            throw new Error('`endpointUrl` should be passed via options');
        }

        api.get(this.options.endpointUrl).then((result) => {
            if (!result.data) return;

            const responseElement = HtmlHelper.createElement(result.data);
            const banners = [...responseElement.querySelectorAll('[data-banner-instance]')];

            const userMembershipsData = userService.getDataFromLocalStorage(CookieNames.TOCH_USER_MEMBERSHIPS);
            const userMemberships = userMembershipsData != null ? JSON.parse(userMembershipsData).split(';') : null;
            const bannersToBeDisplayed = [];

            for (let i = banners.length - 1; i >= 0; i -= 1) {
                const bannerData = this.getBannerIfItShouldBeDisplayed(userMemberships, banners[i]);

                if (bannerData !== null) {
                    bannersToBeDisplayed.push(bannerData);
                }
            }

            if (bannersToBeDisplayed.length > 0) {
                const cookieName = 'lastDisplayedBanner' + this.options.componentId;
                const myCookie = userService.getDataFromLocalStorage(cookieName);

                let currentBannerID = 1;
                if (myCookie != null) {
                    if (parseInt(myCookie) > bannersToBeDisplayed.length) userService.setDataInLocalStorage(cookieName, bannersToBeDisplayed.length);
                    currentBannerID = parseInt(myCookie) + 1;

                    if (currentBannerID > bannersToBeDisplayed.length) currentBannerID = 1;
                }

                const banner = bannersToBeDisplayed[currentBannerID - 1];
                this.element.insertAdjacentElement('beforeend', banner);
                this.addListener(banner, 'click', () => this.onBannerClick(banner));

                userService.setDataInLocalStorage(cookieName, currentBannerID);
            }
        });
    }

    onBannerClick = (bannerElement) => {
        const pageName = this.options.pageName;
        const name = this.getAttribute(bannerElement, 'name');
        const category = this.getAttribute(bannerElement, 'category');
        const action = this.getAttribute(bannerElement, 'action');
        const label = this.getAttribute(bannerElement, 'label');
        let finalLabel = label || name;
        if (pageName) {
            finalLabel = `${pageName} > ${finalLabel}`;
        }

        gtm.push(category, action, finalLabel);
    }
}

export default BannerComponent;
